<script>
import scrollbarWidth from 'scrollbar-width';
import Select from 'element-ui/lib/select';
import { DIRECTION } from '@/store/types';

const mountedHandler = Select.mounted;

Select.computed.dir = function dir() {
  return this.$store.getters[DIRECTION];
};

Select.watch.dir = function watchDirection(dir, prevDir) {
  if (dir === prevDir) {
    return;
  }

  justifyScrollbar.call(this, scrollbarWidth(), dir);
};

Select.mounted = function mounted() {
  mountedHandler.call(this);
  // Fixing the RTL issue on initial load
  justifyScrollbar.call(this, scrollbarWidth(), this.dir);
};

function justifyScrollbar(gutter, direction) {
  this.$nextTick(() => {
    const dropdownWrap = this.$refs.popper.$el.querySelector(
      '.el-scrollbar__wrap',
    );
    const dropdownStyle = dropdownWrap.style;

    if (direction === 'rtl') {
      dropdownStyle.marginRight = 'auto';
      dropdownStyle.marginLeft = `-${gutter}px`;
    } else if (direction === 'ltr') {
      dropdownStyle.marginRight = `-${gutter}px`;
      dropdownStyle.marginLeft = 'auto';
    }
  });
}

export default Select;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/select.css';
// Adding RTL support to element's input

.el-select {
  display: block;
  width: 100%;

  @include rtl() {
    input {
      padding-right: 10px;
      padding-left: 35px;
    }

    .el-tag {
      margin: 2px 6px 2px 0;
    }

    .el-tag__close.el-icon-close {
      left: -7px;
      right: 0;
    }
  }

  .el-select-dropdown__wrap {
    min-height: 60px;
  }
}

.el-scrollbar__bar {
  @include rtl() {
    right: auto;
    left: 2px;
  }
}

.el-select-dropdown {
  &__item.selected {
    &::after {
      @include rtl() {
        left: 20px;
        right: auto !important;
      }
    }
  }

  .popper__arrow {
    @include rtl() {
      left: auto !important;
      right: 35px !important;

      &::after {
        margin-left: 0;
        margin-right: -6px;
      }
    }
  }
}
</style>
